import {Component, OnInit} from '@angular/core';
import {Card} from '../../models/card';
import { Router} from '@angular/router';
import {WELCOME_VIEW} from '../../app.constants';
import {AuthService} from "../../services/auth.service";
import {TokenStorageService} from "../../services/token-storage.service";

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.css']
})
export class WelcomeComponent implements OnInit {
  services: Card[];
  habilitations: any;
  habilitation: any;

  color = 'bg-cyan';
  dashBoard = WELCOME_VIEW;

  constructor(
    private router: Router,
    public authService: AuthService,
    public tokenStorageService: TokenStorageService,
  ) {

  }

  ngOnInit(): void {
    this.habilitation = this.tokenStorageService.getHabilitation();
    this.initFront();
  }

  initFront() {
    const idFenetre = 30280;
    this.authService.returnListAction(idFenetre);
    this.habilitations = this.tokenStorageService.getHabilitations();

    // if(this.habilitations && this.habilitations.length == 1) {
    //   this.onSelectService(this.habilitations[0]);
    // }
  }
  onSelectService(item): void {
    this.tokenStorageService.saveHabilitation(item.id);
    this.onLoadCurrentDomaine();
  }
  onLoadCurrentDomaine(): void {
    this.habilitation = this.tokenStorageService.getHabilitation();
    window.location.reload();
    console.log(this.habilitation);
  }

  goToUrl(url): void {
    this.router.navigate([url]);
  }

}
